// Go-live checklist, rendered in /admin - Launch. Checkbox state persists in localStorage.

export const LAUNCH_STEPS = [
  {
    id: "domain",
    title: "1. Cut over the domain",
    detail: "Redeploy this site on Emergent, point claruspartners.com.au DNS at it, and enable the 'Search Engine Crawling' (bot-prerender) toggle at deploy time. Once live, view-source the production URL and confirm the title tag, meta description, canonical and JSON-LD are in the served HTML.",
  },
  {
    id: "calendly",
    title: "2. Calendly check",
    detail: "Site copy now says 30-minute consultation to match your live Calendly event ('Complimentary Intro Call', 30 min). Optional polish: rename the event to 'Free 30-minute consultation'. If you'd rather run 20-minute calls, shorten the event in Calendly, then ask me to flip the site copy to 20.",
  },
  {
    id: "ga4",
    title: "3. Google Analytics 4",
    detail: "Create a GA4 property at analytics.google.com, copy the Measurement ID (G-XXXXXXX) into Admin - Tracking. Page views and the three conversion events (book_consultation_click, checklist_download, quote_form_submit) start flowing immediately.",
  },
  {
    id: "gsc",
    title: "4. Google Search Console",
    detail: "Add claruspartners.com.au as a property, verify with the meta tag method, paste the token into Admin - Tracking, then submit https://claruspartners.com.au/sitemap.xml.",
  },
  {
    id: "ads",
    title: "5. Google Ads",
    detail: "Create the account, set up a conversion action (note the AW- ID and label) and paste both into Admin - Tracking. Build the campaign from the Advertising Plan kit: phrase-match keywords, day-one negatives, the 5 ad variations, traffic to /xero-health-check. Start at $25/day.",
  },
  {
    id: "gbp",
    title: "6. Google Business Profile",
    detail: "Create a service-area business profile (Australia-wide, no street address shown). Add services, link the site, and start collecting reviews from day one - even 3-5 reviews change conversion.",
  },
  {
    id: "compliance",
    title: "7. Compliance before spend",
    detail: "Confirm: CPA Public Practice Certificate + PI insurance (min $2m, By-Law 9.8) [NIMA TO CONFIRM], GST registration [NIMA TO CONFIRM], employer consent for outside practice [NIMA TO CONFIRM], and a lawyer's pass over the engagement letter template.",
  },
  {
    id: "test",
    title: "8. End-to-end test",
    detail: "On the live domain: submit the checklist form and the quote form (confirm both emails arrive and the leads appear in Admin - Leads), run the plan quiz, and book a real Calendly slot from the embedded widget. Then turn the ads on.",
  },
];
